import { useActivities } from '../../hooks/activity/useActivities'
import { useActivityLogs } from '../../hooks/activity/useActivityLogs'
import { useChallengeContext } from '../../hooks/challenge/useChallengeContext'
import {
  useHasEngagement,
  useRecordEngagement,
} from '../../hooks/engagement/useUserEngagements'
import { useChallengeAccess } from '../../hooks/membership/useChallengeAccess'
import { useRestDays } from '../../hooks/restDays/useRestDays'
import ActivityLogic from '../../logic/ActivityLogic'
import FullscreenVideoOverlay from '../../ui/primitives/FullscreenVideoOverlay'

export default function FinishLineVideo({ children }: { children: JSX.Element }) {
  const { teamID } = useChallengeAccess()
  const { data: challengeContext } = useChallengeContext()
  const { data: activities } = useActivities()
  const { data: activityLogs } = useActivityLogs()
  const { count: restDayCount, isLoading: restDaysLoading } = useRestDays()
  const { mutate: recordEngagement } = useRecordEngagement()

  const challengeId = challengeContext?.challengeId
  const hasSeen = useHasEngagement('finish_line', challengeId)

  if (!teamID || !challengeContext || !activityLogs || !activities || restDaysLoading) {
    return children
  }
  if (hasSeen) return children

  if (
    !ActivityLogic.hasFinished(
      activityLogs,
      activities,
      challengeContext.buckets,
      challengeContext.challenge,
      restDayCount,
    )
  ) {
    return children
  }

  const finishLineVideo = challengeContext.challenge.finishLineVideoUrl
  if (!finishLineVideo || !challengeId) return children

  function onClose() {
    recordEngagement({ subjectType: 'finish_line', subjectID: challengeId! })
  }

  return <FullscreenVideoOverlay videoUrl={finishLineVideo} onClose={onClose} />
}
